import { combineReducers } from "redux";

import personalCreditReducer from "./personalCreditReducer";

const rootReducer = combineReducers({
	personalCreditReducer,
});

export default rootReducer;